export * from './FileFormatXlsIcon';
export * from './FileFormatXlsIcon16Light';
export * from './FileFormatXlsIcon16Regular';
export * from './FileFormatXlsIcon16Solid';
export * from './FileFormatXlsIcon20Light';
export * from './FileFormatXlsIcon20Regular';
export * from './FileFormatXlsIcon20Solid';
export * from './FileFormatXlsIcon24Regular';
export * from './FileFormatXlsIcon24Solid';
export * from './FileFormatXlsIcon32Regular';
export * from './FileFormatXlsIcon64Regular';
